import * as React from 'react';
import './index.scss';
import classNames from 'classnames';
export function CnSafeArea(props) {
    const { position = 'bottom', className } = props;
    const halfRef = React.useRef(null);
    const [needOffset, setNeedOffset] = React.useState(false);
    React.useEffect(() => {
        if (position !== 'bottom')
            return;
        const temp = (() => {
            const dom = halfRef.current;
            if (!dom)
                return false;
            try {
                const domStyle = dom.getBoundingClientRect();
                return domStyle.height > 0;
            }
            catch { }
            return false;
        })();
        setNeedOffset(temp);
    }, [position]);
    if (position === 'bottom') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: halfRef, className: classNames('cn-ui-m-half-safe-area-inset-bottom', className) }),
            needOffset ? (React.createElement("div", { className: "cn-ui-m-half-safe-area-inset-bottom-offset" })) : null));
    }
    return null;
}
CnSafeArea.displayName = 'CnSafeArea';
